// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICardProductionDateInfoDto
 */
export interface ICardProductionDateInfoDto {
    /**
     * 
     * @type {Date}
     * @memberof ICardProductionDateInfoDto
     */
    card_production_date: Date;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICardProductionDateInfoDto
     */
    card_production_date_state?: IFieldStateType;
}



/**
 * Check if a given object implements the ICardProductionDateInfoDto interface.
 */
export function instanceOfICardProductionDateInfoDto(value: object): value is ICardProductionDateInfoDto {
    if (!('card_production_date' in value) || value['card_production_date'] === undefined) return false;
    return true;
}

export function ICardProductionDateInfoDtoFromJSON(json: any): ICardProductionDateInfoDto {
    return ICardProductionDateInfoDtoFromJSONTyped(json, false);
}

export function ICardProductionDateInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardProductionDateInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'card_production_date': (new Date(json['card_production_date'])),
        'card_production_date_state': json['card_production_date_state'] == null ? undefined : IFieldStateTypeFromJSON(json['card_production_date_state']),
    };
}

export function ICardProductionDateInfoDtoToJSON(json: any): ICardProductionDateInfoDto {
    return ICardProductionDateInfoDtoToJSONTyped(json, false);
}

export function ICardProductionDateInfoDtoToJSONTyped(value?: ICardProductionDateInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_production_date': ((value['card_production_date']).toISOString()),
        'card_production_date_state': IFieldStateTypeToJSON(value['card_production_date_state']),
    };
}

